import React, { useState } from "react";
import { Wrapper } from "./LoginForm.styled";
import { Input, Button, Form, SuccessNotification, ErrorNotification, message } from "components/common";
import { callGetApiWithAuth, callPostApi } from "utils/api";
import { saveStorage } from "utils/auth";
import { useHistory } from "react-router";
import { useEffect } from "react";

const LoginForm = () => {
    const history = useHistory();

    const [isloading, setIsLoading] = useState(false);

    const SuccessCall = (data) => {
        setIsLoading(false);
        SuccessNotification("Login Successful");
        saveStorage(data);
        data?.user?.role === "Setter" ? history.push("/setter-leader-board") : history.push("/closer-leader-board");
    };

    const onFinish = (values) => {
        setIsLoading(true);
        callPostApi(
            "/auth/login",
            {
                ...values,
                email: values?.email?.toLowerCase(),
            },
            SuccessCall,
            onFinishFailed
        );
    };

    const onFinishFailed = () => {
        setIsLoading(false);
        ErrorNotification("Error: Login Failed");
    };

    const tokenExpired = () => {
        callGetApiWithAuth("/isTokenExpired", isGetTokenSuccess, isGetTokenFailed);
    };

    const isGetTokenSuccess = (data) => {};

    const isGetTokenFailed = (err) => {
        console.log(err);
    };

    // useEffect(() => {
    //   tokenExpired();
    // }, []);

    return (
        <Wrapper>
            <div className="form-container">
                <div className="heading-conatiner">
                    <h1>LOGIN TO CONTINUE</h1>
                </div>
                <div className="form-details-conatiner">
                    <Form name="basic" initialValues={{ remember: true }} onFinish={onFinish} autoComplete="off">
                        <Form.Item name="email" rules={[{ required: true, message: "Please input your email!" }]}>
                            <div className="email-container">
                                <Input type="email" placeholder="Email" />
                            </div>
                        </Form.Item>
                        <Form.Item name="password" rules={[{ required: true, message: "Please input your password!" }]}>
                            <div className="password-container">
                                <Input type="password" placeholder="Password" />
                            </div>
                        </Form.Item>

                        <Form.Item>
                            <div className="login-button-conatiner">
                                <Button className="btn-background-overlay" title="LOGIN" type="primary" htmlType="submit" loading={isloading} />
                            </div>
                        </Form.Item>
                        <label className="forget-password">
                            <a
                                href=""
                                onClick={() => {
                                    history.push("/forgot-password");
                                }}
                            >
                                Forgot Password
                            </a>
                        </label>
                    </Form>
                </div>
            </div>
        </Wrapper>
    );
};
export default LoginForm;
